import React from 'react';
import ContentLoader from 'react-content-loader';

function Skeleton() {    
    return (
        <ContentLoader                        
            height={192}
            speed={0.5}
            backgroundColor="#f1f1f1"
            foregroundColor="#ebebeb"                   
            width="100%"
            data-testid="skeleton"
        >
            <rect x="14" y="0" rx="3" ry="3" width="150" height="14" />
            <rect x="14" y="22" rx="3" ry="3" width="48%" height="30" />
            <rect x="51%" y="0" rx="3" ry="3" width="150" height="14" />
            <rect x="51%" y="22" rx="3" ry="3" width="48%" height="30" />                

            <rect x="14" y="70" rx="3" ry="3" width="150" height="14" />
            <rect x="14" y="92" rx="3" ry="3" width="48%" height="30" />
            <rect x="51%" y="70" rx="3" ry="3" width="150" height="14" />
            <rect x="51%" y="92" rx="3" ry="3" width="48%" height="30" />                

            <rect x="14" y="140" rx="3" ry="3" width="150" height="14" />
            <rect x="14" y="162" rx="3" ry="3" width="48%" height="30" />
            <rect x="51%" y="140" rx="3" ry="3" width="150" height="14" />
            <rect x="51%" y="162" rx="3" ry="3" width="48%" height="30" />
        </ContentLoader>
    );        
}

export { Skeleton };
